import { Component, OnInit } from '@angular/core';
import { NgForm, FormBuilder, FormGroup, FormControl, Validators} from '@angular/forms';
import { AuthService, WMAIApiService, AppInformationService } from '../core/services';
import { WgisService } from '../wgis/wgis.service';
import { Language, User, Word} from '../core/models';
import { TranslateService } from '@ngx-translate/core';
import { Angulartics2 } from 'angulartics2';
import { SuiModalService, TemplateModalConfig, ModalTemplate, ModalSize } from 'ng2-semantic-ui';
import { ConfirmModal, SimpleModal } from 'src/app/core/templates';
import { Router } from '@angular/router';
// import * as admin from 'firebase-admin';
declare var $: any;

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html'
})
export class SettingsComponent implements OnInit {

  passwordError = false;
  passwordSuccess = false;
  languages: Word[] = [];
  nationalities: Word[] = [];
  ageranges: Word[] = [];
  genders: Word[] = [];
  selectedLanguage: string;
  isUserLoggedIn = false;
  username: string;
  email: string;

  mySettingsProfile: User = new User();
  backUpSetting: User;
  privatedata = true;
  publicdata = false;

  formAbilitato = true;
  formPassAbilitato = true;

  privateexp = false;
  publicexp = false;

  constructor(
    private formBuilder: FormBuilder,
    private auth: AuthService,
    private wgisservice: WgisService,
    private translateService: TranslateService,
    private wmaiservice: WMAIApiService,
    private angulartics2: Angulartics2,
    private modalService: SuiModalService,
    private appService: AppInformationService,
    private router: Router,
  ) { 
    this.wgisservice.setMapInvisible();
    this.isUserLoggedIn = this.auth.isUserLoggedIn();

    this.angulartics2.eventTrack.next({ 
      action: 'submit', 
      properties: {label : 'SettingsChangePassword' },
    });

    this.angulartics2.eventTrack.next({ 
      action: 'changeLanguage', 
      properties: {label : 'SettingsChangeLanguage' },
    });

    this.angulartics2.eventTrack.next({ 
      action: 'onChangeLanguage', 
      properties: {label : 'SettingsChangeLanguage' },
    });
  }

  ngOnInit() {

    $('#languages').dropdown();

    this.wmaiservice.getLanguages().subscribe(data => {
      this.languages.push(...data);
    });

    this.wmaiservice.getWords('agerange').subscribe(data => {
      this.ageranges.push(...data);
    });

    this.wmaiservice.getWords('nationality').subscribe(data => {
      this.nationalities.push(...data);
    });

    var genderLang = this.translateService.getDefaultLang() + 'gender';
    this.wmaiservice.getWords(genderLang).subscribe(data => {
      this.genders.push(...data);
    });

    this.wmaiservice.getProfileSettings().subscribe(data =>{
      this.copyDataInForm(data[0]);
      this.backUpSetting = Object.assign({}, this.mySettingsProfile);
      // console.log(data[0]);
    });
  }
  
  /** si copiano i dati nel form
   * @param  {} data
   */
  copyDataInForm(data){
    if(data.locale == null)
      this.mySettingsProfile.locale = '';
    else
      this.mySettingsProfile.locale = data.locale;

    if(data.nationality == null)
      this.mySettingsProfile.nationality = '';
    else
      this.mySettingsProfile.nationality = data.nationality;

    if(data.agerange == null)
      this.mySettingsProfile.agerange = 0;
    else
      this.mySettingsProfile.agerange = data.agerange;

    if(data.gender == null)
      this.mySettingsProfile.gender = 121;
    else
      this.mySettingsProfile.gender = data.gender;
    
    if(data.news == null)
      this.mySettingsProfile.news = false;
    else
      this.mySettingsProfile.news = data.news;
    
    if(data.cc == null)
      this.mySettingsProfile.cc = false;
    else
      this.mySettingsProfile.cc = data.cc;

    if(data.privacy == null)
      this.mySettingsProfile.privacy = false;
    else
      this.mySettingsProfile.privacy = data.privacy;
    
    if(data.alert == null)
      this.mySettingsProfile.alert = false;
    else
      this.mySettingsProfile.alert = data.alert;

    if(data.email == null)
      this.mySettingsProfile.email = '';
    else
      this.mySettingsProfile.email = data.email;

    if (data.domain == null)
      this.mySettingsProfile.domain = 'basic'; 
    else 
      this.mySettingsProfile.domain = data.domain;
  }
  /** scatena una richiesta 
   * @param  {NgForm} form
   */
  submit(form: NgForm) {
    if(!form.valid) {
      return false;
    }

    this.passwordError = false;
    this.passwordSuccess = false;
    let username = localStorage.getItem('username');

    this.auth.resetPassword(username, form.value.password).subscribe(
      data => {
        this.passwordSuccess = Array.isArray(data) && data.length > 0 ? true : false;
        this.passwordError = Array.isArray(data) && data.length == 0 ? true : false;
        let titlec: string = this.translateService.instant('modal.settings.update.title');
        let contentc: string = this.translateService.instant('modal.settings.update.content');
        this.modalService
        .open(new SimpleModal(titlec, contentc, ModalSize.Tiny))
        .onApprove(() => "")
        .onDeny(() => "");
      }
    );
    form.resetForm();
    this.formPassAbilitato = true;
  }
  /**
   * si cambia la lingua
   */
  changeLanguage(): void {
    if (this.selectedLanguage != null) {
      localStorage.setItem('locale', this.selectedLanguage);
    }
    this.username = localStorage.getItem('username');
    if (this.isUserLoggedIn) {
      this.wmaiservice.setLanguage(this.selectedLanguage,this.username).subscribe(data => data);
    }

    this.appService.changeDefaultLang(this.mySettingsProfile.locale);
  }
  /**
   * attiva i settaggi
   */
  submitSettings(){
    this.wmaiservice.profileUpdate(this.mySettingsProfile).subscribe(data => {
      this.appService.changeDefaultLang(this.mySettingsProfile.locale);
      let titlec: string = this.translateService.instant('modal.settings.update.title');
      let contentc: string = this.translateService.instant('modal.settings.update.content');
      this.modalService
      .open(new SimpleModal(titlec, contentc, ModalSize.Tiny))
      .onApprove(() => "")
      .onDeny(() => "");
    });
    this.formAbilitato = true;
  }

  editForm(){
    this.formAbilitato = false;
  }

  editPassForm(){
    this.formPassAbilitato = false;
  }

  annulEditForm(){
    this.mySettingsProfile = Object.assign({}, this.backUpSetting);
    this.formAbilitato = true;
  }

  annulEditPassForm(form: NgForm){
    form.resetForm();
    this.formPassAbilitato = true;
  }
  /**
   * si elimina l'acoount
   */
  deleteAccount() {
    let title: string = this.translateService.instant('modal.settings.delete.title');
    let content:string = this.translateService.instant('modal.settings.delete.content');
    this.modalService
    .open( new ConfirmModal(title,content, ModalSize.Normal))
    .onApprove(() => {
      if (this.privatedata) {
        this.wmaiservice.deletePrivateExperiences().subscribe(data => {
        });
      }

      if (this.publicdata) {
        this.wmaiservice.deletePublicExperiences().subscribe(data => {
        });
      }
      this.wmaiservice.deleteUser().subscribe(data => {

        // if (localStorage.getItem('domain') !== 'basic') {
        //  const userRecord =  admin.auth().getUserByEmail(localStorage.getItem('username')).then((user) => {
        //    admin.auth().deleteUser(user.uid).then((el) => {
        //     console.log('Cancellazione remota avvenuta con successo');
        //    }).catch((error) => {
        //     console.log('Impossibile cancellare l\'utente');
        //    });
        //  }).catch((error) => {
        //   console.log('Impossibile trovare l\'utente');
        //  });
        // }

        let title: string = this.translateService.instant('modal.settings.deleteuser.title');
        let content: string = this.translateService.instant('modal.settings.deleteuser.content');
        this.modalService
        .open(new SimpleModal(title, content, ModalSize.Tiny))
        .onApprove(() => {
        })
        .onDeny(() => {
          this.auth.logout();
          this.router.navigateByUrl('/');
        });
      });

    })
    .onDeny(() => "");
  }
}
